export * from './open-virtual-assistant.directive';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/open-virtual-assistant/index.ts